import { render, staticRenderFns } from "./primary-links.vue?vue&type=template&id=4dbfff99&scoped=true&lang=pug"
import script from "./primary-links.vue?vue&type=script&lang=coffee"
export * from "./primary-links.vue?vue&type=script&lang=coffee"
import style0 from "./primary-links.vue?vue&type=style&index=0&id=4dbfff99&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbfff99",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TextLink: require('/opt/build/repo/site/components/globals/text-link.vue').default})
